'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAuthErrorToastFromSearchParams } from '@/app/(auth)/_hooks/use-auth-error-toast-from-search-params';
import { AuthBranch } from '@/app/(auth)/_partials/auth-branch';
import { useUtmParams } from '@/hooks/use-utm-params';
import { useSignUpFlowStore } from '../_hooks/use-sign-up-flow-store';
import { useSignUpStepUrlSync } from '../_hooks/use-sign-up-step-url-sync';
import { SignUpChooseSessionControl } from './sign-up-choose-session';
import { SignUpChooseSessionExperiment } from './sign-up-choose-session-experiment';
import { SignUpEmailVerificationControl } from './sign-up-email-verification';
import { SignUpEmailVerificationExperiment } from './sign-up-email-verification-experiment';
import { SignUpFormControl } from './sign-up-form';
import { SignUpFormExperiment } from './sign-up-form-experiment';
function useResetStoreOnMount(): void {
  const searchParams = useSearchParams();
  const hasReset = useRef(false);
  if (!hasReset.current) {
    hasReset.current = true;
    const requestedStep = searchParams.get('step');
    if (requestedStep !== 'choose') {
      useSignUpFlowStore.getState().reset();
    }
  }
}
export function SignUp() {
  const $ = _c(10);
  useUtmParams();
  useResetStoreOnMount();
  useAuthErrorToastFromSearchParams();
  useSignUpStepUrlSync();
  const step = useSignUpFlowStore(_temp);
  let t0;
  if ($[0] !== step) {
    t0 = step === "start" ? <AuthBranch><AuthBranch.Control><SignUpFormControl /></AuthBranch.Control><AuthBranch.Experiment><SignUpFormExperiment /></AuthBranch.Experiment></AuthBranch> : null;
    $[0] = step;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== step) {
    t1 = step === "email-verification" ? <AuthBranch><AuthBranch.Control><SignUpEmailVerificationControl /></AuthBranch.Control><AuthBranch.Experiment><SignUpEmailVerificationExperiment /></AuthBranch.Experiment></AuthBranch> : null;
    $[2] = step;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== step) {
    t2 = step === "choose" ? <AuthBranch><AuthBranch.Control><SignUpChooseSessionControl /></AuthBranch.Control><AuthBranch.Experiment><SignUpChooseSessionExperiment /></AuthBranch.Experiment></AuthBranch> : null;
    $[4] = step;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t0 || $[7] !== t1 || $[8] !== t2) {
    t3 = <div className="flex w-full flex-col items-center justify-center">{t0}{t1}{t2}</div>;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(s) {
  return s.step;
}